import { render } from "./ico-sound.vue?vue&type=template&id=6146b753&ts=true"
import script from "./ico-sound.vue?vue&type=script&lang=ts"
export * from "./ico-sound.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__